const ACCORDION_ROWS = [1, 2, 3, 4, 5]
const ITEM_ROWS = [1, 2, 3, 4]
const MOBILE_TABS = [1, 2, 3, 4, 5]
const SIDEBAR_TILES = [1, 2, 3]
const LOW_ROWS = [1, 2, 3]

function SkeletonLine({ className = '' }) {
  return <div className={`pantry-skeleton-line ${className}`.trim()} />
}

function SkeletonItemRow() {
  return (
    <div className="pantry-skeleton-item-row">
      <SkeletonLine className="pantry-skeleton-item-name" />
      <SkeletonLine className="pantry-skeleton-item-qty" />
    </div>
  )
}

function SkeletonAccordion({ expanded = false }) {
  return (
    <div className={`pantry-skeleton-accordion${expanded ? ' pantry-skeleton-accordion--expanded' : ''}`}>
      <div className="pantry-skeleton-accordion__trigger">
        <SkeletonLine className="pantry-skeleton-accordion__icon" />
        <SkeletonLine className="pantry-skeleton-accordion__label" />
        <SkeletonLine className="pantry-skeleton-accordion__count" />
      </div>
      {expanded ? (
        <div className="pantry-skeleton-accordion__body">
          {ITEM_ROWS.map((row) => (
            <SkeletonItemRow key={row} />
          ))}
        </div>
      ) : null}
    </div>
  )
}

function DesktopSkeleton() {
  return (
    <div className="pantry-v2__main-grid pantry-skeleton-grid" aria-hidden="true">
      <div>
        <div className="pantry-v2__sections-head pantry-skeleton-sections-head">
          <div className="pantry-skeleton-toolbar-actions">
            <SkeletonLine className="pantry-skeleton-btn" />
            <SkeletonLine className="pantry-skeleton-btn pantry-skeleton-btn--narrow" />
          </div>
        </div>
        <div className="pantry-v2__accordions">
          {ACCORDION_ROWS.map((row, index) => (
            <SkeletonAccordion key={row} expanded={index === 0} />
          ))}
        </div>
      </div>

      <aside className="pantry-v2__sidebar pantry-skeleton-sidebar">
        <section className="pantry-skeleton-sidebar-card">
          <SkeletonLine className="pantry-skeleton-sidebar-eyebrow" />
          <SkeletonLine className="pantry-skeleton-sidebar-title" />
          <SkeletonLine className="pantry-skeleton-sidebar-cta" />
          <div className="pantry-skeleton-sidebar-tiles">
            {SIDEBAR_TILES.map((tile) => (
              <SkeletonLine key={tile} className="pantry-skeleton-sidebar-tile" />
            ))}
          </div>
        </section>
        <section className="pantry-skeleton-sidebar-card">
          <SkeletonLine className="pantry-skeleton-sidebar-card-title" />
          {LOW_ROWS.map((row) => (
            <SkeletonLine key={row} className="pantry-skeleton-low-row" />
          ))}
        </section>
        <section className="pantry-skeleton-sidebar-card pantry-skeleton-sidebar-card--ai">
          <SkeletonLine className="pantry-skeleton-sidebar-card-title" />
          <SkeletonLine className="pantry-skeleton-sidebar-body" />
          <SkeletonLine className="pantry-skeleton-sidebar-body pantry-skeleton-sidebar-body--short" />
        </section>
      </aside>
    </div>
  )
}

function MobileSkeleton() {
  return (
    <div className="pantry-skeleton-mobile" aria-hidden="true">
      <div className="pantry-v2__mobile-stat-chips pantry-skeleton-stat-chips">
        <div className="pantry-v2__mobile-stat-chip pantry-skeleton-stat-chip">
          <SkeletonLine className="pantry-skeleton-stat-label" />
          <SkeletonLine className="pantry-skeleton-stat-value" />
        </div>
      </div>
      <hr className="pantry-v2__stat-divider" />

      <div className="pantry-skeleton-toolbar-actions pantry-skeleton-toolbar-actions--mobile">
        <SkeletonLine className="pantry-skeleton-btn" />
        <SkeletonLine className="pantry-skeleton-btn pantry-skeleton-btn--narrow" />
      </div>

      <div className="pantry-v2__mobile-tabs pantry-skeleton-mobile-tabs">
        {MOBILE_TABS.map((tab, index) => (
          <div
            key={tab}
            className={`pantry-skeleton-mobile-tab${index === 0 ? ' pantry-skeleton-mobile-tab--active' : ''}`}
          >
            <SkeletonLine className="pantry-skeleton-mobile-tab-icon" />
            <SkeletonLine className="pantry-skeleton-mobile-tab-label" />
          </div>
        ))}
      </div>

      <div className="pantry-skeleton-accordion pantry-skeleton-accordion--expanded">
        <div className="pantry-skeleton-accordion__body">
          {ITEM_ROWS.map((row) => (
            <SkeletonItemRow key={row} />
          ))}
          {ITEM_ROWS.map((row) => (
            <SkeletonItemRow key={`extra-${row}`} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default function PantrySkeleton({ isMobile = false }) {
  return (
    <div className="pantry-skeleton" role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Loading pantry</span>
      {isMobile ? (
        <MobileSkeleton />
      ) : (
        <>
          <div className="pantry-skeleton-stats-line" aria-hidden="true">
            <SkeletonLine className="pantry-skeleton-stats-segment" />
            <SkeletonLine className="pantry-skeleton-stats-segment pantry-skeleton-stats-segment--short" />
          </div>
          <DesktopSkeleton />
        </>
      )}
    </div>
  )
}
